import { Component, Input } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
    selector: 'pim-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.sass'],
    standalone: false
})
export class TooltipComponent {

	@Input()
	iconClass: string = 'fa-info-circle';

	@Input()
	tooltipText: string = '';

	@Input()
	position: TooltipPosition = 'above';

	@Input()
	tooltipClass: string = '';

	constructor() {
	}

}
